import { History } from '@mui/icons-material';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

import { PositionGeocode } from '@/domain/position-geocode/position-geocode.entity';

export function PositionFillFromHistoryButton({
  positions,
  onClickItem,
}: {
  positions: PositionGeocode[];
  onClickItem: (position: PositionGeocode) => void;
}) {
  const [anchorEl, setAnchorEl] = useState<undefined | HTMLElement>(undefined);

  const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(undefined);
  };

  const onMenuItemClick = (position: PositionGeocode) => {
    onClickItem(position);
    onClose();
  };

  return (
    <>
      <IconButton
        onClick={onClick}
        disabled={positions.length === 0}
        color="primary"
        sx={{ height: '1rem', width: '1rem' }}
      >
        <History />
      </IconButton>
      <Menu open={Boolean(anchorEl)} onClose={onClose} anchorEl={anchorEl}>
        {positions.map((position, index) => (
          <MenuItem key={index} onClick={() => onMenuItemClick(position)}>
            {position.properties.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
